import { render, staticRenderFns } from "./PAPerformance.vue?vue&type=template&id=3e67031a&"
import script from "./PAPerformance.vue?vue&type=script&lang=js&"
export * from "./PAPerformance.vue?vue&type=script&lang=js&"
import style0 from "./PAPerformance.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PAPerformance.vue"
export default component.exports